<template>
    <!-- 跟frontend_ambassador開始有差異，填寫邏輯跟更動主要在那裏，設定邏輯寫在這裡，這裡存在部分填寫但驗證邏輯並不完整 -->
    <Form v-if="values.application_title !== undefined" :schema="schema" :values="values" class="prog-set-form-wrap"
        :class="{ 'is-error': is_error, 'only_view': only_view, 'for-fill-in': type === 'fillin' }" ref="form_ref">
        <div class="preview-title" v-if="only_view">Preview</div>
        <el-button text  class="only-view-svg" @click="$emit('close_only_view')" v-if="only_view">
            <svg-icon name="close"/>
        </el-button>
        <Scrollbar class="data-list" :show_bar="true" :key="key_refrash">
            <div :class="['logo', only_view && 'logo-only-view']" @click="showUpload=true">
                <i v-if="!only_view" ><svg-icon name="pen"/></i>
                <img v-if="data.preview_logo_image_url" :src="data.preview_logo_image_url "
                    alt="logo">
                <img v-else-if="store.state.user_data.merchant_account" :src="store.state.user_data.merchant_account.store_front_logo" alt="logo"/>
            </div>
            <!-- title-box -->
            <div class="from-box title-box">
                <el-button class="edit-btn" @click="editSetting('title')"><svg-icon name="pen" />Edit</el-button>
                <div class="content">
                    <div v-if="values.application_title" :class="['title', (only_view && !values.summary.val) && 'title-big-only']" :key="key_refrash_left">{{ values.application_title.val }}</div>
                    <div v-if="values.summary" :class="['text', !values.summary.val && 'desc', (only_view && !values.summary.val) && 'title-big-only']">{{ values.summary.val ? values.summary.val : !only_view ? `Click Edit to change program name or summary.`:'' }}
                    </div>
                </div>
            </div>

            <!-- about-us-box -->
            <div class="from-box about-us-box" v-if="values.creator_arr">
                <el-button class="edit-btn" @click="editSetting('creator')"><svg-icon name="pen" />Edit</el-button>
                <div class="content">
                    <div class="title">{{ creator_title }}</div>
                    <div class="question"
                        v-for="(v, k) in values.creator_arr.filter(e => { return e.show && e.label !== 'last_name' })"
                        :key="k" v-show="v.show">
                        <label :class="['label', v.is_required && 'label-req']">{{ v.name }}</label>
                        <div class="text-light" v-if="v.spec_val">{{ v.spec_val }}</div>

                        <div
                            :class="['field-box', (lastNameValueIndex !== -1 && v.label === 'full_name') && 'field-flex-box']">
                            <Field :type="v.client_type" :k="v.label" :placeholder="v.plac" :had_value="v.val"
                                :date_format="v.plac" :min_date="v.min_date" :max_date="v.max_date"
                                :select_data="v.input_option" :is_disabled="is_edit_setting"
                                :default_date="v.default_date" :error_msg="errors[v.label]"
                                :is_success="success[v.label]" @update="update" :ref="(el) => { if (el) els.push(el) }"
                                :spec="'creator_arr'" :dropdown_use="'text'" />
                            <!-- last name要注意位子 -->
                            <Field v-if="lastNameValueIndex !== -1 && v.label === 'full_name'"
                                :type="values.creator_arr[lastNameValueIndex].client_type"
                                :k="values.creator_arr[lastNameValueIndex].label"
                                :placeholder="values.creator_arr[lastNameValueIndex].plac"
                                :had_value="values.creator_arr[lastNameValueIndex].val"
                                :is_disabled="is_edit_setting"
                                :error_msg="errors[values.creator_arr[lastNameValueIndex].label]"
                                :is_success="success[values.creator_arr[lastNameValueIndex].label]" @update="update"
                                :ref="(el) => { if (el) els.push(el) }" :spec="'creator_arr'" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- custom-box mighy lot of-->
            <div :class="['from-box custom-box', handleCustomUi(v, 'err') && 'custom-box-err', handleCustomUi(v, 'success') && 'custom-box-success']"
                v-for="(v, k) in values.custom_arr" :key="k">
                <el-button class="edit-btn" @click="editSetting('custom_question', v)"><svg-icon name="pen" />Edit</el-button>
                <div class="content content-cus">
                    <div class="question">
                        <label :class="['label', v.is_required && 'label-req']">{{ v.label }}</label>
                        <br/><label class="label-text" v-if="v.client_type==='multi_select' || v.client_type==='single_select'">{{ v.name_type }}:</label>

                        <Field :type="v.client_type" :k="v.label" :placeholder="v.plac" :had_value="v.val"
                            :is_disabled="is_edit_setting" :select_data="v.input_option" :max_value="v.max_value"
                            :error_msg="errors[v.label]" :is_success="success[v.label]" @update="update"
                            :ref="(el) => { if (el) els.push(el) }" :spec="'custom_arr'" />
                    </div>
                </div>
            </div>

            <!-- btn-box -->
            <div class="btn-box" v-if="!only_view && type !== 'fillin'">
                <div class="editList" v-if="open_list_val.val" :class="'menu-type-' + menu_type" ref="edit_list_ref">
                    <div class="tit">Form</div>
                    <div class="item" v-for="(item, index) in open_list_val.list" :key="index"
                        @click.stop="selectType(open_list_val.type, index)" v-show="!item.is_add">
                        <span>{{ item.text }} </span>
                    </div>
                </div>
                <el-button size="large" v-if="values.custom_arr.length < custom_question_val.max" @click.stop="openList('cus')">
                    <svg-icon name="plus" />Custom Question({{ values.custom_arr.length }}/{{ custom_question_val.max }})
                </el-button>
                <el-button size="large" v-for="(item, index) in sections_val.list" :key="index"
                    v-show="!item.is_add" @click.stop="selectType(2, index)">
                    <svg-icon name="plus" />{{ item.text }}
                </el-button>
            </div>

            <!-- parent-box-->
            <div class="from-box parent-box" v-if="blockShow.parent">
                <el-button :class="['edit-btn', (parent_value.edit_err && type !=='create') && 'err-edit-btn']"
                    @click="editSetting('parent_guardian_consent')"><svg-icon name="pen" />Edit</el-button>
                <div class="content">
                    <div class="title">Parent / Guardian Consent</div>
                    <div class="desc desc-text" v-if="parent_value.desc_open">{{ parent_value.int }}</div>

                    <div class="question"
                        v-for="(v, k) in values.parent_arr.filter(e => { return e.group_label !== 'parent_guardian_consent_disclaimer_confirm' && e.label !== 'parent_guardian_introduction' && e.tag!=='for_url'})"
                        :key="k">
                        <label :class="['label', v.is_required && 'label-req']">{{ v.name }}</label>
                        <Field :type="v.client_type" :k="v.label" :placeholder="v.plac" :had_value="v.val"
                            :date_format="v.plac" :min_date="v.min_date" :max_date="v.max_date"
                            :is_disabled="is_edit_setting" :default_date="v.default_date" :error_msg="errors[v.label]"
                            :is_success="success[v.label]" @update="update" :ref="(el) => { if (el) els.push(el) }"
                            :spec="'parent_arr'" />
                    </div>
                    <div :class="['term-box', parent_value.term_err_mes && 'term-box-err']">
                        <div class="text flex">Please read our Parental/Guardian Consent Disclaimer and confirm the
                            following:<div class="red">*</div>
                        </div>
                        <div class="checkbox-box"
                            v-for="(v, k) in values.parent_arr.filter(e => { return e.group_label === 'parent_guardian_consent_disclaimer_confirm' })"
                            :key="k" @click="hanleCheckbox(v)">
                            <Checkbox :checked="v.val" />
                            <div class="text" v-html="v.name"></div>
                        </div>
                        <div class="err-mes" v-if="parent_value.term_err_mes">
                            {{ parent_value.term_err_mes }}<svg-icon name="alert" class="icon-left" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- Social Accounts-->
            <div class="from-box social-box" v-if="blockShow.social">
                <el-button class="edit-btn" @click="editSetting('social_account')"><svg-icon name="pen" />Edit</el-button>
                <div class="content social-box-content">
                    <div class="title">Social Accounts</div>
                    <div class="desc desc-text" v-if="social_value.desc_open">{{ values.social_account_arr.some(e=> e.client_type === 'connect') ? ` You must connect either your Instagram or TikTok.`:`You must enter either your Instagram or TikTok.`}}</div>
                    <div class="question" v-for="(v, k) in values.social_account_arr" :key="k">
                        <div class="item-box" v-if="v.show">
                            <div class="line-box">
                                <div :class="['label', v.is_required && 'label-req']"><svg-icon v-if="v.icon"
                                        :name="v.icon" />{{ v.name }}</div>
                                <el-button v-if="v.client_type === 'connect'" class="connet-btn"
                                    :type="!v.val ? 'primary' : 'default'">
                                    {{ !v.val ? 'Connect' : 'Connected' }}
                                </el-button>

                                <div class="for-you-url-box"
                                    v-if="v.client_type === 'url' || v.client_type === 'url-handle'">
                                    <Field type="text" :k="v.label" :placeholder="v.plac" :had_value="v.val"
                                        :is_disabled="is_edit_setting" :error_msg="errors[v.label]"
                                        :is_success="success[v.label]" @update="update" :ref="(el) => { if (el) els.push(el) }"
                                        :spec="'social_account_arr'" />
                                </div>
                            </div>

                        </div>
                        <div class="err-mes" v-if="social_value.connet_err_mes && v.label === 'instagram'">
                            {{ social_value.connet_err_mes }}<svg-icon name="alert" class="icon-left" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- term-box-->
            <div class="from-box term-box"
                v-if="values.agreements_disclaimers_arr && values.agreements_disclaimers_arr.length > 0">
                <el-button :class="['edit-btn', (term_value.edit_err && type !=='create') && 'err-edit-btn']"
                    @click="editSetting('agreements_disclaimers')"><svg-icon name="pen" />Edit</el-button>
                <div :class="['content', (term_value.term_err_mes) && 'term-box-err']">
                    <div class="text trem-text" v-for="(v, k) in values.agreements_disclaimers_arr" :key="k"
                        v-show="v.show">
                        <div class="trem-text-check-box checkbox-box" @click="hanleCheckbox(v)">
                            <Checkbox :checked="type === 'fillin' ? v.val : false" :value="k"
                                :disabled="is_edit_setting" />
                            <p v-html="v.name"></p>
                        </div>
                    </div>
                    <div class="err-mes" v-if="term_value.term_err_mes">
                        {{ term_value.term_err_mes }}<svg-icon name="alert" class="icon-left" />
                    </div>
                </div>
            </div>
            <el-button type="primary" class="submit-btn" :disabled="!is_can_save" @click="submit">
                {{ only_view || type === 'fillin' ? 'Submit' : 'Save' }}
            </el-button>
        </Scrollbar>
    </Form>
    <!-- edit_popup -->
    <ProgTitleEdit v-if="edit_value.title" :data="handle_data.basic" :is_show="edit_value.title"
        @close="edit_value.title = false" @save="saveSetting"/>

    <ProgCreatorEdit v-if="edit_value.creator" :data="handle_data.basic" :is_show="edit_value.creator"
        :porgram_for_who="porgram_for_who" @close="edit_value.creator = false;checkIfTerm()" @save="saveSetting" :type="type" :is_copy="is_copy"  :other_data="data"/>

    <Modal :is_show="edit_value.parent_guardian_consent" @click-bg="edit_value.parent_guardian_consent = false" class="add-creator-modal add-parent-modal edit-program-set-pop">
        <ProgParentEdit v-if="edit_value.parent_guardian_consent" :data="handle_data.parent_guardian_consent" @close="edit_value.parent_guardian_consent = false"
            @save="saveSetting" @hide="sections_val.list[sections_val.parent_id].is_add = false; hideNot();" :pro_title="values.application_title.val"/>
    </Modal>


    <ProgSocialEdit v-if="edit_value.social_account" :data="handle_data.social_account"
        :is_show="edit_value.social_account" @close="edit_value.social_account = false" @save="saveSetting"
        @hide="sections_val.list[sections_val.social_id].is_add = false;hideNot();" />

    <ProgCustomEdit v-if="edit_value.custom_question" :key="cus_key_refrash" :data="get_cus_value" :is_can_delete="is_can_delete"
        :is_show="edit_value.custom_question" @close="edit_value.custom_question = false" @save="saveSetting"
        @del="delCustom" />

    <ProgAgreementEdit v-if="edit_value.agreements_disclaimers" :data="handle_data.agreements_disclaimers"
        :is_show="edit_value.agreements_disclaimers" @close="edit_value.agreements_disclaimers = false"
        @save="saveSetting" :brand_name="brand_name" />

    <UploadAvatar save_button_text="Next" @save="saveImage" v-if="showUpload" @closeModal="closeLogoModal" :img_url="data.preview_logo_image_url">
        <template #desc>
            <div class="desc">The default logo is currently set to the one from your portal settings. This doesn't have to match the portal logo. <span class='blue'>Click here </span> to reset to the default logo.
                <br/><br/>
                Please upload a PNG image (max size: 200KB). Recommend to use PNG image with transparent background.
            </div>
        </template>
    </UploadAvatar>

</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onUnmounted, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import Modal from '@/components/ui/Modal.vue';
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import ProgCreatorEdit from './ProgCreatorEdit.vue';
import ProgTitleEdit from './ProgTitleEdit.vue';
import ProgParentEdit from './ProgParentEdit.vue';
import ProgCustomEdit from './ProgCustomEdit.vue';
import ProgAgreementEdit from './ProgAgreementModal.vue';
import ProgSocialEdit from './ProgSocialEdit.vue';
import UploadAvatar from '@/components/UploadAvatar.vue';
import { ElButton } from 'element-plus';
import * as yup from 'yup';
import { getIndex, CustomQuestion, FromSettingYup, CustomYupRules, blockStatus, handleParentUrl } from '@/utils/ProgramsData.js';

const store = useStore();
const { proxy } = getCurrentInstance();

const props = defineProps({
    data: { type: Object, default: () => ({}) },
    type: { type: String, default: 'create' },
    othet_data: { type: Object, default: () => ({}) },
    is_edit_setting: { type: Boolean, default: false },
    only_view: { type: Boolean, default: false },
    porgram_for_who: { type: [String, Number], default: 0 },
    is_copy: { type: Boolean, default: false },
    key_refrash_left: { type: [String, Number], default: 0 },
    key_refrash_left_country: { type: [String, Number], default: 0 },
    is_first_create: { type: Boolean, default: false },
    is_can_save: { type: Boolean, default: false },
});

const emit = defineEmits(['close_only_view', 'update-data', 'save-form', 'handle_old_data']);

// Template refs
const form_ref = ref(null);
const edit_list_ref = ref(null);

// Data
const values = ref({});
const handle_data = ref({});
const els = ref([]);
const is_error = ref(false);
const is_disabled_click = ref(false);
const schema = ref(yup.object().shape({}));
const errors = ref({});
const success = ref({});
const get_cus_value = ref({});
const key_refrash = ref(0);
const cus_key_refrash = ref(0);
const menu_type = ref('');
const is_can_delete = ref(false);
const showUpload = ref(false);

const edit_value = reactive({
    title: false,
    creator: false,
    parent_guardian_consent: false,
    social_account: false,
    custom_question: false,
    agreements_disclaimers: false,
});

const open_list_val = reactive({
    val: false,
    type: 1,
    title: 'Question type',
    list: [],
});

const sections_val = reactive({
    title: 'Section type',
    parent_id: 0,
    social_id: 1,
    list_value: [
        { text: 'Parent / guardian consent', id: 0, is_add: false, can_edit: false, type: 'parent', field: 'parent_guardian_consent' },
        { text: 'Social accounts', id: 1, is_add: false, can_edit: false, type: 'social', field: 'social_account' },
    ],
    list: [
        { text: 'Parent / guardian consent', is_add: false, id: 0, field: 'parent_guardian_consent' },
        { text: 'Social accounts', is_add: false, id: 1, field: 'social_account' },
    ],
});

const custom_question_val = reactive({
    title: 'Custom Question',
    list: [
        { text: 'Single select question', id: 0 },
        { text: 'Multiple select question', id: 1 },
        { text: 'Short answer question', id: 2 },
        { text: 'Long answer question', id: 3 },
    ],
    max: 6,
});

const parent_value = reactive({
    int: '',
    desc_open: false,
    term_err_mes: '',
    edit_err: '',
});

const social_value = reactive({
    desc_open: false,
    connet_err_mes: '',
});

const custom_value = reactive({ is_new: false });

const term_value = reactive({
    term_err_mes: '',
    edit_err: false,
});

// Computed
const brand_name = computed(() =>
    store.state.user_data?.merchant_account?.merchant_display_name
);

const brand_id = computed(() =>
    store.state.user_data?.merchant_account?.id
);

const program_title = computed(() => {
    if (!handle_data.value.basic) return '';
    const index = getIndex(handle_data.value.basic, 'title', 'application_title');
    return handle_data.value.basic[index.i].question[index.ii].client_view.val;
});

const creator_title = computed(() => {
    if (!handle_data.value.basic) return 'Tell Us About Yourself...';
    const index = getIndex(handle_data.value.basic, 'tell_us_about_yourself_title', 'tell_us_about_yourself_title');
    if (handle_data.value.basic[index.i].can_edit) {
        return handle_data.value.basic[index.i].question[index.ii].client_view.val;
    }
    return 'Tell Us About Yourself...';
});

const lastNameValueIndex = computed(() =>
    values.value.creator_arr?.findIndex(e => e.label === 'last_name') ?? -1
);

const blockShow = computed(() => {
    const is_fillin = props.type === 'fillin';
    return {
        parent:
            (sections_val.parent_id !== -1 && sections_val.list[sections_val.parent_id]?.is_add) ||
            (is_fillin && handle_data.value.parent_guardian_consent?.length > 0),
        social:
            (sections_val.social_id !== -1 && sections_val.list[sections_val.social_id]?.is_add) ||
            (is_fillin && handle_data.value.social_account?.length > 0),
    };
});

// Watch
watch(() => props.key_refrash_left, (val) => {
    if (val) {
        const new_title = props.data.basic[0].question[0].client_view.val;
        handle_data.value.basic[0].question[0].client_view.val = new_title;
        values.value.application_title.val = new_title;
    }
});

watch(() => props.key_refrash_left_country, (val) => {
    if (val) {
        const index = getIndex(props.data.basic, 'country_location', 'country_location');
        const new_val = props.data.basic[index.i].is_required;
        handle_data.value.basic[index.i].is_required = new_val;
        handle_data.value.basic[index.i].is_switch = new_val;
        createValuesAndSchema(handle_data.value);
    }
});

// Methods
const createUUID = () =>
    'xxxxxxxx'.replace(/[x]/g, () => (Math.random() * 16 | 0).toString(16));

const editSetting = (val, get_val) => {
    if (props.only_view || props.type === 'fillin') return;
    edit_value[val] = true;
    if (val === 'custom_question') {
        is_can_delete.value = true;
        const index = handle_data.value.custom_question.findIndex(item => item.cus_id === get_val.cus_id);
        get_cus_value.value = handle_data.value.custom_question[index];
        custom_value.is_new = false;
        edit_value.custom_question = true;
    } else {
        is_can_delete.value = false;
    }
};

const saveSetting = (val) => {
    if (val.type === 'creator' || val.type === 'title') {
        handle_data.value.basic = val.data;
        emit('update-data', { field: val.type, val: val.data, ambassador_application_template_id: val.ambassador_application_template_id });
    } else if (val.type === 'custom_question') {
        if (custom_value.is_new === true) {
            val.data.cus_id = createUUID();
            val.data.is_new = true;
            handle_data.value[val.type].push(val.data);
        } else {
            for (let i = 0; i < handle_data.value[val.type].length; i++) {
                if (handle_data.value[val.type][i].cus_id === val.data.cus_id) {
                    handle_data.value[val.type][i] = val.data;
                    break;
                }
            }
        }
        emit('update-data', { field: val.type, val: handle_data.value[val.type] });
    } else {
        handle_data.value[val.type] = val.data;
        emit('update-data', { field: val.type, val: val.data });
    }

    if (val.type === 'agreements_disclaimers') term_value.edit_err = false;
    if (val.type === 'parent_guardian_consent') parent_value.edit_err = false;

    createValuesAndSchema(handle_data.value);
    edit_value[val.type] = false;

    if (val.type === 'creator' && !val.ambassador_application_template_id) {
        checkIfTerm();
    }
    key_refrash.value += 1;
};

const saveImage = () => {};

const checkIfTerm = () => {
    if (values.value.agreements_disclaimers_arr?.length > 0) {
        const hasEmptyUrl = values.value.agreements_disclaimers_arr.some(e => e.url === '');
        if (hasEmptyUrl) editSetting('agreements_disclaimers');
    }
};

const getData = () => {
    if (props.is_first_create) editSetting('creator');
    handle_data.value = JSON.parse(JSON.stringify(props.data));
    handleParentUrl(handle_data.value.parent_guardian_consent, brand_name.value, program_title.value);
    handleDiffrentTemplate();
    handleBlockOpen();
    createValuesAndSchema(handle_data.value);
    setTimeout(() => {
        emit('handle_old_data', { handle_data: handle_data.value, block: sections_val.list, tip: 'old' });
    }, 100);
};

const handleDiffrentTemplate = () => {
    sections_val.list_value[0].can_edit = handle_data.value.parent_guardian_consent?.length > 0;
    sections_val.list_value[1].can_edit = handle_data.value.social_account?.length > 0;
    sections_val.list = sections_val.list_value.filter(e => e.can_edit);
    sections_val.parent_id = sections_val.list.findIndex(item => item.type === 'parent');
    sections_val.social_id = sections_val.list.findIndex(item => item.type === 'social');
};

const handleBlockOpen = () => {
    if (handle_data.value.block_status) {
        sections_val.list.forEach(e => {
            const item = handle_data.value.block_status.find(ee => ee.name === e.field);
            if (item) e.is_add = item.open;
        });
    }
};

const handleCustomUi = (v, type) => {
    const check_field = v.tag === 'add_single_select_question' || v.tag === 'add_multiple_select_question';
    if (type === 'err') return errors.value[v.label] && check_field;
    return success.value[v.label] && check_field;
};

const createValuesAndSchema = (formSetting) => {
    const vals = {
        creator_arr: [],
        parent_arr: [],
        social_account_arr: [],
        required_at_least_1: [],
        custom_arr: [],
        agreements_disclaimers_arr: [],
    };
    let schemaShape = {};

    const handleAllData = (question, group) => {
        if (group.is_switch) {
            if (question.hasOwnProperty('is_switch') && question.client_view) {
                question.client_view.show = question.is_switch;
                question.show = question.is_switch;
            } else if (question.index === 0) {
                question.client_view.show = group.is_switch;
                question.show = group.is_switch;
            }
        } else {
            group.is_required = false;
            if (question.client_view) question.client_view.show = false;
        }
        if (question.client_view) {
            const label = question.label;
            if (FromSettingYup[label]) question.client_view.yup_rule = FromSettingYup[label];
        }
        return question;
    };

    const handleAllRequired = (group, question) => {
        if (group.setting_number === 1) {
            group.is_switch = true;
            group.is_required = true;
        } else if (group.is_required === undefined) {
            group.is_required = false;
        }
        if (question) {
            if (group.hasOwnProperty('is_required') && question.client_view && question.index === 0) {
                question.client_view.is_required = group.is_required;
            } else if (question.client_view) {
                if (question.client_view.setting_number === 1) {
                    question.client_view.is_required = true;
                } else if (question.client_view.setting_number === 2) {
                    question.client_view.is_required = group.is_required;
                }
            }
        }
    };

    const handleAllScem = (question) => {
        if (question.client_view?.yup_rule && question.client_view.show) {
            schemaShape[question.label] = question.client_view.yup_rule;
            const required = schemaShape[question.label].required;
            if (question.client_view.is_required && schemaShape[question.label] && typeof required === 'function') {
                const name = question.client_view.title || question.client_view.name;
                schemaShape[question.label] = schemaShape[question.label].required(`The ${name} can't be left blank`);
            }
        }
    };

    // basic
    formSetting.basic.forEach(group => {
        group.question.forEach(question => {
            handleAllData(question, group);
            handleAllRequired(group, question);

            if (group.group_name === 'address' && question.label === 'address_placeholder') {
                question.client_view.spec_val = group.question[1].val;
            }

            if (group.group_name === 'date_of_birth' && question.label === 'date_of_birth') {
                question.client_view.plac = group.question[1].can_edit ? group.question[1].val : question.client_view.plac;
                question.client_view.max_date = null;
                question.client_view.default_date = question.client_view.max_date || '';

                if (proxy.$ProjectName === 'sephora') {
                    if (question.input_type === 'toggle') question.client_view.plac = question.client_view.plac.replace(/\/YYYY|YYYY\//g, '');
                    if (question.input_type === 'single_select') {
                        question.input_value = question.val.replace(/\/YYYY|YYYY\//g, '');
                        question.val = question.val.replace(/\/YYYY|YYYY\//g, '');
                        question.input_option.forEach(e => { e.text = e.text.replace(/\/YYYY|YYYY\//g, ''); });
                    }
                }
            }

            if (group.group_name === 'title' || group.group_name === 'summary' || (group.group_name === 'tell_us_about_yourself_title' && group.can_edit)) {
                vals[question.label] = question.client_view;
            } else if (question.client_view && group.can_edit && question.can_edit && question.client_view.show) {
                vals.creator_arr.push({ ...question.client_view, label: question.label });
            }

            if (group.can_edit && question.can_edit) handleAllScem(question);
        });
    });

    // parent
    formSetting.parent_guardian_consent.forEach(group => {
        group.question.forEach(question => {
            handleAllData(question, group);
            handleAllRequired(group, question);

            if (group.group_name === 'parent_guardian_introduction') {
                parent_value.desc_open = group.is_switch;
            }
            if (group.group_name === 'parent_guardian_introduction' && question.label === 'parent_guardian_introduction') {
                parent_value.int = question.client_view.val || question.client_view.plac;
            }

            if (question.client_view && question.can_edit && question.client_view.show) {
                vals.parent_arr.push({ ...question.client_view, label: question.label, group_label: group.group_name, tag: group.tag });
                handleAllScem(question);
            }
        });
    });

    // social
    formSetting.social_account.forEach(group => {
        handleAllRequired(group);
        if (group.group_name === 'required_at_least_1') {
            social_value.desc_open = group.is_required;
        }
        if (group.connect && group.can_edit) {
            group.connect.client_view = {
                ...group.connect.client_view,
                show: group.is_switch,
                is_required: group.is_switch && group.is_required,
                label: group.group_name,
            };
            if (FromSettingYup[group.group_name]) group.connect.client_view.yup_rule = FromSettingYup[group.group_name];
            vals.social_account_arr.push(group.connect.client_view);
            if (group.connect.client_view.show) {
                schemaShape[group.group_name] = group.connect.client_view.yup_rule;
                const required = schemaShape[group.group_name].required;
                if (group.connect.client_view.is_required && schemaShape[group.group_name] && typeof required === 'function') {
                    schemaShape[group.group_name] = schemaShape[group.group_name].required(`The ${group.connect.client_view.name} can't be left blank`);
                }
            }
        } else {
            vals.required_at_least_1 = group;
        }
    });

    // custom_question
    formSetting.custom_question.forEach((group, k) => {
        if (group.client_view) {
            if (CustomYupRules[group.label]) group.client_view.yup_rule = CustomYupRules[group.label];
            const client_view = {
                ...group.client_view,
                id: k,
                type_id: group.id,
                cus_id: group.cus_id,
                max_value: group.max_value,
                tag: group.label,
                show: true,
            };
            vals.custom_arr.push(client_view);
            if (group.client_view.yup_rule) {
                schemaShape[client_view.label] = client_view.yup_rule;
                const yupDescription = schemaShape[client_view.label].describe();
                const hasRequired = yupDescription.tests.some(test => test.name === 'required');
                if (client_view.is_required && schemaShape[client_view.label] && !hasRequired) {
                    schemaShape[client_view.label] = schemaShape[client_view.label].required(`The ${client_view.label} can't be left blank`);
                }
            }
        }
    });

    // agreements_disclaimers
    formSetting.agreements_disclaimers.forEach(group => {
        group.question.forEach(question => {
            handleAllData(question, group);
            handleAllRequired(group, question);

            let isMacy = false;
            if (window.location.host === 'www.anchor.motom.me' || window.location.host === 'anchor.motom.me') {
                isMacy = brand_id.value === 106;
            } else {
                isMacy = brand_id.value === 56;
            }

            if (question.label === 'i_confirm_that_i_am_18_years_or_older' && !question.is_switch) {
                question.client_view.show = false;
            } else if (question.client_view) {
                question.client_view.show = true;
            }

            if (question.label === 'i_have_read_and_acknowledge_privacy_policy') {
                question.url = question.url || '';
                if (isMacy) {
                    question.client_view.name = `By continuing, you agree that you are subject to ${question.url ? `<a href="${question.url}" class="link" target="_blank">Influencer Notice of Privacy Practices</a>` : 'Influencer Notice of Privacy Practices'}.`;
                    question.client_view.desc = `By continuing, you agree that you are subject to "Influencer Notice of Privacy Practices.`;
                } else {
                    question.client_view.name = `I have read and acknowledge the ${brand_name.value} ${question.url ? `<a href="${question.url}" class="link" target="_blank">Privacy Policy</a>` : 'Privacy Policy'}.`;
                    question.client_view.desc = `I have read & acknowledge the ${brand_name.value} Privacy Policy.`;
                }
            }

            if (question.label === 'i_have_read_and_acknowledge_terms_and_conditions') {
                question.url = question.url || '';
                if (isMacy) {
                    question.client_view.name = `By continuing, you agree that you are subject to the ${question.url ? `<a href="${question.url}" class="link" target="_blank">Influencer Legal Notice</a>` : 'Influencer Legal Notice'}.`;
                    question.client_view.desc = `By continuing, you agree that you are subject to the Influencer Legal Notice.`;
                } else {
                    question.client_view.name = `I have read and agree to the ${brand_name.value} ${question.url ? `<a href="${question.url}" class="link" target="_blank">Terms & Conditions</a>` : 'Terms & Conditions'}.`;
                    question.client_view.desc = `I have read & agree to the ${brand_name.value} Terms & Conditions.`;
                }
            }

            if (question.client_view && question.can_edit) {
                vals.agreements_disclaimers_arr.push({ ...question.client_view, label: question.label, url: question.url });
                handleAllScem(question);
            }
        });
    });

    schema.value = yup.object().shape(schemaShape);
    values.value = vals;
};

const updateFormSettingWithValues = () => {
    const updateValues = (question, valuesGroup) => {
        const value = valuesGroup.find(v => v.label === question.label);
        if (value && question.client_view) {
            question.client_view.val = value.val || value.default_val || '';
        }
    };
    handle_data.value.basic.forEach(group => {
        group.question.forEach(question => {
            if (values.value[question.label]) {
                question.client_view.val = values.value[question.label].val || values.value[question.label].default_val || '';
            }
            updateValues(question, values.value.creator_arr);
        });
    });
    handle_data.value.parent_guardian_consent.forEach(group => {
        group.question.forEach(question => updateValues(question, values.value.parent_arr));
    });
    handle_data.value.social_account.forEach(group => {
        if (group.connect && values.value.social_account_arr.length > 0) {
            const value = values.value.social_account_arr.find(v => v.label === group.group_name);
            if (value) group.connect.client_view.val = value.val || value.default_val || '';
        }
    });
    handle_data.value.custom_question.forEach(group => {
        const value = values.value.custom_arr.find(v => v.tag === group.label);
        if (value) group.client_view.val = value.val || value.default_val || '';
    });
    handle_data.value.agreements_disclaimers.forEach(group => {
        group.question.forEach(question => updateValues(question, values.value.agreements_disclaimers_arr));
    });
};

const update = (obj) => {
    is_error.value = false;
    if (!obj.spec) {
        Object.keys(values.value).forEach(key => {
            if (key === obj.key) values.value[key].val = obj.val;
        });
    }
};

const hanleCheckbox = (v) => {
    if (props.type === 'fillin') v.val = !v.val;
};

const hideNot = () => {
    emit('handle_old_data', { handle_data: handle_data.value, block: sections_val.list, tip: 'new' });
    proxy.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Section hidden.`);
};

const specSocialValidate = () => {
    if (social_value.desc_open) {
        const hasNonEmptyVal = values.value.social_account_arr.some(e => e.tag === 'connet' && e.val);
        social_value.connet_err_mes = hasNonEmptyVal ? '' : 'You must connect either your Instagram or TikTok';
    }
};

const specValidate = async () => {
    errors.value = {};
    success.value = {};

    const schemaShape = Object.keys(values.value).reduce((acc, key) => {
        if (Array.isArray(values.value[key])) {
            values.value[key].forEach(item => {
                if (item.show) acc[item.label] = schema.value.fields[item.label];
            });
        } else if (values.value[key].show) {
            acc[key] = schema.value.fields[key];
        }
        return acc;
    }, {});

    const dynamicSchema = yup.object().shape(schemaShape);

    const validationValues = Object.keys(values.value).reduce((acc, key) => {
        if (Array.isArray(values.value[key])) {
            values.value[key].forEach(item => {
                if (item.show) acc[item.label] = item.val;
            });
        } else {
            acc[key] = values.value[key].val;
        }
        return acc;
    }, {});

    try {
        await dynamicSchema.validate(validationValues, { abortEarly: false });
        Object.keys(validationValues).forEach(key => { success.value[key] = true; });
        return true;
    } catch (err) {
        const firstErrorPaths = new Set();
        err.inner.forEach(error => {
            if (!firstErrorPaths.has(error.path)) {
                errors.value[error.path] = error.message;
                firstErrorPaths.add(error.path);
            }
        });

        values.value.parent_arr.some(e => {
            if (e.tag === 'term' && errors.value[e.label]) {
                parent_value.term_err_mes = 'Please confirm our Parental/Guardian Consent Disclaimer and confirm the following.';
                return true;
            }
            return false;
        });

        values.value.agreements_disclaimers_arr.some(e => {
            if (e.tag === 'term' && errors.value[e.label]) {
                term_value.term_err_mes = 'Please confirm these.';
                return true;
            }
            return false;
        });

        if (!values.value.parent_arr.some(e => e.tag === 'term' && errors.value[e.label])) {
            parent_value.term_err_mes = '';
        }
        if (!values.value.agreements_disclaimers_arr.some(e => e.tag === 'term' && errors.value[e.label])) {
            term_value.term_err_mes = '';
        }

        specSocialValidate();
        Object.keys(validationValues).forEach(key => { success.value[key] = !errors.value[key]; });
        return false;
    }
};

const checkEditing = () => {
    term_value.edit_err = false;
    if (handle_data.value.agreements_disclaimers?.length > 0) {
        handle_data.value.agreements_disclaimers.forEach(e => {
            e.question.forEach(qes => {
                if ((qes.label === 'privacy_policy_url' || qes.label === 'terms_and_conditions_url') && !qes.val) {
                    term_value.edit_err = true;
                }
            });
        });
    }
    parent_value.edit_err = false;
    if (handle_data.value.parent_guardian_consent?.length > 0) {
        handle_data.value.parent_guardian_consent.forEach(e => {
            e.question.forEach(qes => {
                if ((qes.label === 'parent_guardian_read_acknowledge_disclaimer_url' || qes.label === 'parent_guardian_read_and_acknowledge_terms_conditions_and_privacy_policy_url') && !qes.client_view.val) {
                    parent_value.edit_err = true;
                }
            });
        });
    }
};

const submit = async () => {
    if (props.only_view) return;
    if (props.is_edit_setting) {
        checkEditing();
        const for_back_data = JSON.parse(JSON.stringify(handle_data.value));
        if (!blockShow.value.parent) for_back_data.parent_guardian_consent = [];
        if (!blockShow.value.social) for_back_data.social_account = [];
        const hadErr = term_value.edit_err || (parent_value.edit_err && blockShow.value.parent);
        const err_mes = [];
        if (term_value.edit_err) err_mes.push('Agreements & Disclaimers');
        if (parent_value.edit_err && blockShow.value.parent) err_mes.push('Parent / Guardian Consent');
        emit('save-form', { data: for_back_data, handle: blockStatus, hadErr, err_mes });
    }
};

const openList = (val) => {
    is_disabled_click.value = true;
    setTimeout(() => { is_disabled_click.value = false; }, 100);
    if (val === 'cus') {
        open_list_val.type = 1;
        open_list_val.title = custom_question_val.title;
        open_list_val.list = custom_question_val.list;
        open_list_val.top = 42;
    } else {
        open_list_val.type = 2;
        open_list_val.title = sections_val.title;
        open_list_val.list = sections_val.list;
        open_list_val.top = 84;
    }
    open_list_val.val = menu_type.value === val ? !open_list_val.val : true;
    menu_type.value = val;
};

const selectType = (type, id) => {
    open_list_val.val = false;
    is_can_delete.value = false;
    if (type === 2) {
        sections_val.list[id].is_add = true;
        if (sections_val.list[id].field === 'parent_guardian_consent') editSetting('parent_guardian_consent');
        emit('handle_old_data', { handle_data: handle_data.value, block: sections_val.list, tip: 'new' });
    } else {
        const index = CustomQuestion.findIndex(item => item.id === id);
        get_cus_value.value = JSON.parse(JSON.stringify(CustomQuestion[index]));
        custom_value.is_new = true;
        cus_key_refrash.value += 1;
        edit_value.custom_question = true;
    }
};

const delCustom = (val) => {
    if (custom_value.is_new) {
        edit_value.custom_question = false;
    } else {
        for (let i = 0; i < handle_data.value[val.type].length; i++) {
            if (handle_data.value[val.type][i].cus_id === val.data.cus_id) {
                handle_data.value[val.type].splice(i, 1);
            }
        }
    }
    createValuesAndSchema(handle_data.value);
    edit_value[val.type] = false;
    key_refrash.value += 1;
    emit('update-data', { field: 'custom_question', val: handle_data.value });
};

const handleClick = (e) => {
    if (is_disabled_click.value) {
        is_disabled_click.value = false;
        return;
    }
    if (edit_list_ref.value && !edit_list_ref.value.contains(e.target)) {
        open_list_val.val = false;
    }
};

const closeLogoModal = (val) => {
    if (val) {
        props.data.preview_logo_image_url = val;
        handle_data.value.preview_logo_image_url = val;
    }
    showUpload.value = false;
};

// Lifecycle
onMounted(() => {
    getData();
    window.addEventListener('click', handleClick);
});

onUnmounted(() => {
    window.removeEventListener('click', handleClick);
});

defineExpose({ getData, submit, specValidate, values, handle_data });
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.prog-set-form-wrap {
    @include flexCenter();
    justify-content: center;
    background-color: var(--bg-10);
    height: calc(100vh - 48px);

    .red {
        color: var(--red);
    }

    .flex {
        @include flexCenter;
    }

    .err-edit-btn{
        border:solid 2px var(--red);
    }

    &.only_view {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        background: var(--bg-10);//var(--light-neutral);
        z-index: 1;

        .content .title-big-only{
            margin-bottom:0 !important;
        }

        .edit-btn {
            display: none;
        }

        .only-view-svg {
            position: absolute;
            top: 12px;
            right: 24px;

            svg{
                width: 14px;
                height: 14px;
            }
        }

        .preview-title{
            position: absolute;
            top: 12px;
            left: 24px;
            font: var(--font-demi-24);
        }
    }

    &.for-fill-in {
        .edit-btn {
            display: none;
        }

        .logo {
            border:none;
            cursor:default;
        }
    }

    .data-list {
        padding: 53px;
        width: 100%;

        @media screen and (max-width: 768px) {
            padding: 16px;
        }
    }

    .logo {
        width: 220px;
        height: 100px;
        margin: auto;
        margin-bottom: 28px;
        @include flexCenter();
        overflow: hidden;
        cursor: pointer;
        border: dashed 2px var(--border);
        position: relative;

        &.logo-only-view{
            border: none;
            pointer-events: none;
        }

        i{
            width:16px;
            height:16px;
            position: absolute;
            right: 0;
            top:4px;

            svg{
                width: 12px;
                height: 12px;
                fill:var(--black-50);
            }
        }

        img {
            width: 100%;
            height: 100px;
            object-fit: contain;
        }
    }

    .from-box {
        margin-bottom: 16px;
        padding: 24px 16px;
        position: relative;
        display: flex;
        background-color: var(--white);

        .line {
            color: var(--blue);
        }

        &:first-child {
            margin-top: 24px;
        }

        &:last-child {
            margin-bottom: 24px;
        }

        .content {
            flex: 1;
            margin-left: 16px;

            .title {
                font: var(--font-demi-24);
                margin-bottom: 12px;
            }

            .text {
                font: var(--font-med-14);
                color: var(--black-90);
                margin-bottom: 6px;
                padding: 0 !important;
            }

            .field-flex-box {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 8px;

                @media screen and (max-width: 768px) {
                    grid-template-columns: 1fr;
                    gap: unset;
                }
            }

            .trem-text {
                margin-bottom: 12px;
            }

            .trem-text-check-box {
                @include flexCenter();

                .ui-checkbox {
                    margin: unset;
                }
            }

            .text-light {
                font: var(--font-med-14);
                color: var(--black-75);
                margin-bottom: 6px;
            }

            .desc {
                font-family: var(--font);
                font-size: 14px;
                color: var(--black-50);

                &.desc-text {
                    color: var(--black-90);
                }
            }

            &.content-cus {
                .ui-input {
                    margin-top: 12px;
                }

                .radio-option .ui-checkbox {
                    margin: unset
                }

                .radio-option,
                .ui-input,
                .checkbox-option {
                    display: flex;
                    align-items: center;
                    padding-bottom: 8px;

                    .ui-checkbox {
                        margin: unset;
                    }
                }
            }

            .question {
                margin: 16px 0;
                border-radius: 8px;

                .label {
                    font: var(--font-med-16);
                    color: var(--black-90);
                    display: inline-block;

                    &.label-req:after {
                        content: ' *';
                        color: var(--alert);
                    }
                }

                .label-text{
                    color:var(--black-75);
                }

                .ui-input {
                    margin: 0;
                    margin-top: 4px;
                    width: 100%;
                    display: unset;
                }

                .ui-dropdown {
                    margin-top: 4px;

                    .ui-dropdown--inner .ui-button span {
                        font-size: 14px;
                    }
                }

                .ui-input--date {
                    margin-top: 4px;
                }

                input,
                select {
                    padding: 10px;
                    height: 36px;
                }
            }

            &.social-box-content {
                .line-box {
                    @include flexCenter();
                    justify-content: space-between;

                    .for-you-url-box {
                        width: 100%;
                    }
                }

                .for-you-url-box-handle {
                    margin-left: 32px;

                    .ui-input--wrap {
                        display: grid;
                        grid-template-columns: 1fr 2fr;
                        gap: 8px;
                    }
                }

                .label {
                    @include flexCenter();
                    width: 120px;
                    margin-right: 8px;
                    gap:4px;

                    .svg-icon {
                        width: 20px;
                        height: 20px;

                    }
                }
            }

            .checkbox-box {
                @include flexCenter();
                align-items: flex-start;
                margin-bottom: 4px;
                cursor: pointer;

                .ui-checkbox {
                    margin: unset;
                }
            }
        }

        .custom-box {
            .question:first-child {
                margin: unset;
            }
        }

        .field-box {
            .ui-input--wrap {
                margin-top: 4px;
            }
        }

        .content-cus {
            .question {
                &:first-child {
                    margin: unset;
                }

                .ui-checkbox,
                .is-disabled {
                    opacity: 1;
                }

                .ui-input {
                    margin-top: 8px;

                    .the-input {
                        margin-top: 8px;
                    }
                }
            }
        }

        &.custom-box-err .question {
            border: solid 1px var(--red);
        }

        &.custom-box-success .question {
            border: solid 1px var(--green);
        }

        .term-box-err {
            border-radius: 8px;
            border: solid 1px var(--red);
            margin: 4px;
        }

        .err-mes {
            @include flexCenter();
            justify-content: flex-end;
            text-align: right;
            color: var(--red);
            margin: 4px 0;
            font-size: 12px;

            .svg-icon {
                height: 10px;
                width: 10px;
                fill: var(--red);
                margin: 0 6px 0 4px;
            }
        }

    }

    .el-button{
        span{
            display: flex;
            gap: 4px;
        }
        svg{
            width: 10px;
            height: 10px;
        }
    }

    .btn-box {
        width: 50%;
        margin: auto;
        position: relative;

        .el-button {
            margin-bottom: 16px;
            width: 100%;
            margin-left: 0;
        }

        .editList {
            padding: 8px 0;
            width: 100%;
            background: white;
            border: 1px solid #F2F2F2;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            border-radius: 6px;
            position: absolute;
            z-index: 9;
            right: 0px;
            top: 0;
            transform: translateY(-100%);

            &.menu-type-sec {
                top: 58px;
            }

            .tit {
                padding: 0 9px;
                font: var(--font-med-12);
                color: var(--black-50);
            }

            .item {
                padding: 9px 10px;
                @include flexCenter();
                cursor: pointer;
                color: var(--black-90);
                font: unset;
                font-family: var(--font);
                font-size: 14px;

                &:hover {
                    background: var(--bg-02);
                }

            }
        }
    }

    .submit-btn {
        width: 100%;
        text-align: center;
    }
}
</style>
